import ip from 'ip'

import getIpClient from './getIpClient'
import getPageData from './getPageData'

export default async function () {
  try {
    const pageData = await getPageData();
    const ipClient = await getIpClient();

    const { ipBlocks } = pageData;

    let item = ipBlocks.find(v => {
      return ip.cidrSubnet(v).contains(ipClient)
    });

    return ipBlocks.indexOf(item) !== -1;

  }catch (e) {
     throw e;
  }
}
